export default "__VITE_ASSET__dec6183b__"